const styles = (theme) => ({
    tabRoot: {
        borderRadius: '5px 5px 0 0',
        background: 'white',
        padding: '15px 0 0 15px',
        marginTop: '20px',
    },
    inputRoot: {
        border: '1px solid grey',
        borderRadius: '20px',
        padding: '10px 15px',
        margin: '10px 0',
        background: 'none',
        '&:focus': {
            borderRadius: '20px',
            background: 'none',
        },
        padding:'10px',
    },
    button: {
        background: '#f58634',
        width:"91px",
        color: 'white',
        borderRadius: '20px',
        padding: '9px 16px',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#f58634'
        },
        marginTop:'7px',
        
    },
});

export default styles;
